module.exports = __webpack_public_path__ + "static/img/img_15.27a8cc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_15.jpg
// module id = 188
// module chunks = 20